export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_USER_DETAIL = "SET_USER_DETAIL";
export const SET_LOADING = "SET_LOADING";
export const DELETE_USER_DETAIL = "DELETE_USER_DETAIL";

export const SET_PROFILES_AND_DOCUMENTS = "SET_PROFILES_AND_DOCUMENTS";
export const SET_PROFILES = "SET_PROFILES";
export const SET_SHARED_DOC = "SET_SHARED_DOC";
export const SET_SUGGESTED_TOPICS = "SET_SUGGESTED_TOPICS";
